<template>
    <li class="jc-component__range">
    	<div class="jc-range"  :class='rangeStatus?"successStyle":""'>
            <!-- <div class="jc-range-pop" :style='{width:popWidth+"px"}'></div> -->
    		<i @mousedown="rangeMove" :class='rangeStatus?"successIcon":""'></i>
			<span>
				{{rangeStatus?successText:startText}}
			</span>
    	</div>
    </li>
</template>

<script>

export default {
    props: {
    	//成功文字
    	successText: {
    		type: String,
    		default: '验证成功'
    	},
    	//开始的文字
    	startText: {
    		type: String,
    		default: '按住滑块，拖动到最右边'
    	}
    },
    
    data(){
    	return {
    		disX : 0,
            popWidth:0,
    		rangeStatus: false
    	}
    },
    	
    methods:{
        //滑块移动
    	rangeMove(e){
    		let ele = e.target;
    		let startX = e.clientX;
    		let eleWidth = ele.offsetWidth;
    		let parentWidth =  ele.parentElement.offsetWidth;
    		let MaxX = parentWidth - eleWidth;
    		if(this.rangeStatus){//不运行
    			return false;
    		}
    		document.onmousemove = (e) => {
    			let endX = e.clientX;
    			this.disX = endX - startX;
    			if(this.disX<=0){
    				this.disX = 0;
    			}
    			if(this.disX >= MaxX){//减去滑块的宽度,体验效果更好
    				this.disX = MaxX;
    			}
    			ele.style.transition = '.1s all';
    			ele.style.transform = 'translateX('+this.disX+'px)';
    			e.preventDefault();
    		}
    		document.onmouseup = ()=> {
    			if(this.disX !== MaxX){
    				ele.style.transition = '.1s all';
    				ele.style.transform = 'translateX(0)';
    			}else{
    				this.rangeStatus = true;
    				//执行成功的函数
    				this.successFunction();
    			}
    			document.onmousemove = null;
    			document.onmouseup = null;
    		}
    	},
    	//成功的函数
    	successFunction(){
    		this.$emit('success','ok')
    	}
    }
};
</script>

<style lang="scss" scoped>
	.jc-range{
		position: relative;
		transition: 1s all;
		user-select: none;
	    line-height:42px;
		display: flex;
		align-items: center;
		width: 318px;
		height: 42px;
		background: #CCCCCC;
		border-radius: 10px;
        @include font-style;
		font-size: 14px;
		color: #666666;	
        i{
           width: 79px;
           height: 100%;
           border-radius:8px;
           color: #000;
           background-color: #fff;
           cursor: move;
           background: url(../assets/img/slider.png) no-repeat center;
           background-size: 79px;
           margin-right: 30px; 
        }
        
        .successIcon{
            background: url(../assets/img/success.png) no-repeat right center;
            background-size: 50px 42px;
        }
	}
    
    .jc-range-pop{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0;
        height: 42px;
        border-radius: 10px 0 0 10px;
        background: #7AC23C;
        @include font-style;
        font-size: 14px;
        color: #666666;	
    }
    
    .successStyle{
        background-color: #7AC23C;
        color: #fff;
    }

</style>
